<template>
    <div class="page">
        <div class="wrap1">
            <img class="label2" referrerpolicy="no-referrer"
                src="https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng2a81d621bad95c8a63855bbe8145cea741374b657ce8a0d34d4e6763fd9cb264" />
            <div class="word2">核销失败</div>
            <div class="listBox" v-if="quoteName">
                <div class="itemList">
                    <span>优惠券</span>
                    <span>{{ quoteName }}</span>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
import Cookies from "js-cookie";
export default {
    data() {
        return {
            quoteName: ''
        }
    },
    mounted() {
        try {
            const writeOffData = localStorage.getItem('writeOffData');
            this.quoteName = JSON.parse(writeOffData).quoteName;
            Cookies.remove('token');
            Cookies.remove('secretKey');
        } catch (error) {
            console.error('获取核销数据失败', error);
        }
    }
}
</script>

<style lang="less" scoped>
.page {
    background-color: #F7F8FC;
    display: flex;
    flex-direction: column;
    text-align: center;
    height: 100vh;

}

.wrap1 {
    background-color: #ffffff;
    width: 80%;
    margin: 50px auto;
    border-radius: 10px;
    padding: 20px;
}

.word2 {
    margin: 20px 0;
}


.listBox {
    background-color: #F7F8FC;
    padding: 10px;

    .itemList {
        display: flex;
        align-items: center;

        span:first-child {
            min-width: 70px;
            color: #666;
            flex-shrink: 0;
        }

        span:last-child {
            color: #333;
            flex: 1;
            word-break: break-all;
        }
    }
}
</style>
